import { render, staticRenderFns } from "./Passkeys.vue?vue&type=template&id=5561a1e4&"
import script from "./Passkeys.vue?vue&type=script&lang=js&"
export * from "./Passkeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports